var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/component/x-file-item.ts
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-flex";
import "@adornis/chemistry/elements/components/x-icon";
import "@adornis/chemistry/elements/components/x-progress-bar.js";
import { html, nothing } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { ifDefined } from "lit/directives/if-defined.js";
import { formatFileSize } from "../helper.js";
var XFileItem = class extends ChemistryLitElement {
  firstUpdated(_changedProperties) {
    super.firstUpdated(_changedProperties);
    if (!this.file)
      return;
    if (!["image"].some((type) => this.file.type.includes(type)))
      return;
    const reader = new FileReader();
    reader.onload = () => {
      this.imagePreviewSrc = reader.result;
    };
    reader.readAsDataURL(this.file);
  }
  render() {
    if (!this.file)
      return nothing;
    return html`
      <x-flex
        horizontal
        crossaxis-center
        ${css({ background: "#F7F7F7", padding: "8px", gap: "16px", position: "relative" })}
      >
        <x-flex
          center
          crossaxis-center
          ${css({
      borderRadius: "8px",
      border: "1px solid #FAFAFA",
      background: "#fff",
      overflow: "hidden"
    })}
        >
          ${this.imagePreviewSrc ? html`
                <img
                  src=${ifDefined(this.imagePreviewSrc)}
                  ${css({
      width: "100px",
      aspectRatio: "1 / 1",
      overflow: "hidden",
      objectFit: "cover"
    })}
                />
              ` : html` <x-icon ${css({ fontSize: "24px", padding: "37px" })}> description </x-icon> `}
        </x-flex>
        <x-flex flex ${css({ gap: "8px" })}>
          <x-text ${css({ fontSize: "16px" })}> ${this.file.name} </x-text>
          <x-text ${css({ fontSize: "12px" })}> ${formatFileSize(this.file.size)} </x-text>
          <slot></slot>
        </x-flex>
      </x-flex>
    `;
  }
  styles() {
    return [
      ...super.styles(),
      {
        ":host": {
          display: "contents"
        }
      }
    ];
  }
};
__decorateClass([
  property({ attribute: false })
], XFileItem.prototype, "file", 2);
__decorateClass([
  state()
], XFileItem.prototype, "imagePreviewSrc", 2);
XFileItem = __decorateClass([
  customElement("x-file-item")
], XFileItem);
export {
  XFileItem
};
